import { render } from "./Void.vue?vue&type=template&id=c3166a12"
const script = {}
script.render = render

export default script